/*-----------------------------------------------------*/
// Availability Management
/*-----------------------------------------------------*/

import { deleteConfirmationAlert, timePickerMask } from "./common";

// Calander plugins
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';

window.$(document).ready(function () {
    if (window.$(".container-fluid").hasClass('availabilityHome')) {
        setTimeout(function () {
            $.ajax({
                url: window.$('#getExceptionClosingCount').attr('settingurl'),
                type: 'post',
                dataType: "json",
                data: {
                    _token: window.$('meta[name="csrf-token"]').attr('content'),
                    restaurant_id: window.$('#restaurants').val(),
                },
                success: function (response) {
                    let res = response.data
                    if (res['upcomingCloseTime'] <= 2 && res['pastCloseTime'] == 0) {
                        window.$(".exceptiontable .viewalllink > a").addClass('d-none')
                        //window.$(".viewalllink").hide();
                    } else if (res['upcomingCloseTime'] > 0 && res['pastCloseTime'] == 0) {
                        window.$(".exceptiontable .viewalllink > a").text('View all')
                        window.$(".exceptiontable  .viewalllink").attr("style", "display:block")
                    } else if (res['upcomingCloseTime'] <= 2 && res['pastCloseTime'] >= 1) {
                        window.$(".exceptiontable .viewalllink > a").text('View all history')
                        window.$(".exceptiontable  .viewalllink").attr("style", "display:block")
                    } else if (res['upcomingCloseTime'] > 2 && res['pastCloseTime'] >= 1) {
                        window.$(".exceptiontable .viewalllink > a").text('View all history')
                        window.$(".exceptiontable  .viewalllink").attr("style", "display:block")
                    }
                }
            });
            $.ajax({
                url: window.$('#getPastUpcomingOpenCount').attr('settingurl'),
                type: 'post',
                dataType: "json",
                data: {
                    _token: window.$('meta[name="csrf-token"]').attr('content'),
                    restaurant_id: window.$('#restaurants').val(),
                },
                success: function (response) {
                    let res = response.data
                    console.log(res)
                    if (res['upcomingOpenTime'] <= 2 && res['pastOpenTime'] == 0) {
                        window.$(".exceptionOpeningtable .viewalllink > a").addClass('d-none')

                        //window.$(".viewalllink").hide();
                    } else if (res['upcomingOpenTime'] > 0 && res['pastOpenTime'] == 0) {
                        window.$(".exceptionOpeningtable  .viewalllink > a").text('View all')
                        window.$(".exceptionOpeningtable  .viewalllink").attr("style", "display:block")
                    }
                    else if (res['upcomingOpenTime'] <= 2 && res['pastOpenTime'] >= 1) {
                        window.$(".exceptionOpeningtable  .viewalllink > a").text('View all history');
                        window.$(".exceptionOpeningtable  .viewalllink").attr("style", "display:block")
                    }
                }
            });
        }, 500)
    }
    timePickerMask();
});
window.$(document).ready(function () {
    setTimeout(function(){
        if(!window.$(".exceptionOpenSmallTable").DataTable().data().any()){
            window.$(".viewalllink").hide();
        }else{
            window.$(".viewalllink").show();
        }
    },500)
    
});
var defaultDate = new Date();
window.$(".status_checkbox").each(function (e) {
    $(this).on('change', function () {
        var prevVal = $(this).attr('data-value');
        var ischecked = '';
        let start_val = $(this).closest('td').prev('td').prev('td').find('div:first').find('input').val();
        let end_val = $(this).closest('td').prev('td').find('div:first').find('input').val();
        let start_val_attr = $(this).closest('td').prev('td').prev('td').find('div:first').find('input').attr('data-value');
        let end_val_attr = $(this).closest('td').prev('td').find('div:first').find('input').attr('data-value');
        if ($(this).is(":checked")) {
            ischecked = 'checked';
        }
        else if ($(this).is(":not(:checked)")) {
            ischecked = 'unchecked';
        }
        if (prevVal != ischecked) {
            $(this).closest('tr').find('td:last a').removeClass('disabled');
        } else {
            if (start_val_attr && start_val != start_val_attr.trim()) {
                $(this).closest('tr').find('td:last a').removeClass('disabled');
            }
            if (end_val_attr && end_val != end_val_attr.trim()) {
                $(this).closest('tr').find('td:last a').removeClass('disabled');
            }
            if (start_val_attr && end_val_attr && start_val == start_val_attr.trim() && end_val == end_val_attr.trim()) {
                $(this).closest('tr').find('td:last a').addClass('disabled');
            }

        }
    });
});
// Save availability time block
window.$(".saveavilability").on('click', function (e) {
    e.preventDefault();
    var isValid = true;
    var currentObj = window.$(this);
    setTimeout(function () {
        // disabled class
        $(e.currentTarget).addClass('disabled');
    }, 100)
    var day = window.$(this).data('day');
    var validationFields = { "breakfast": { "validationRequired": false }, "lunch": { "validationRequired": false }, "dinner": { "validationRequired": false } };
    $(".textfield").removeClass('error');
    Object.keys(validationFields).forEach(function (key) {
        var tempArr = [];
        window.$(this).closest("tr").find("." + key).map(function () {
            tempArr.push($(this).val());
        });
        if ((tempArr[0] != '' && tempArr[1] == '') || (tempArr[0] == '' && tempArr[1] != '')) {
            validationFields[key].validationRequired = true;
        }
    }, (window.$(this)));
    //VALIDATION START
    Object.keys(validationFields).forEach(function (key) {
        if (validationFields[key].validationRequired == true) {
            window.$(this).closest("tr").find("." + key).map(function () {
                if (!validationDisplayWithoutMessage(window.$(this))) {
                    isValid = false;
                    return false;
                } else {
                    window.$(this).removeClass('error');
                }
            });
        }
    }, (window.$(this)));
    if (isValid == true) {
        window.axios({
            method: "post",
            url: window.$("#reservationTimeForm").attr('action'),
            data: window.$(this).closest('tr').find('input').serialize() + "&day=" + day,
        }).then(function (response) {
            var responseData = response.data.data;
            if (responseData) {
                responseData.forEach(function (item, index) {
                    var prev_start_time = window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").attr('data-value');
                    var prev_end_time = window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").attr('data-value');
                    if (item.meal == 'breakfast') {
                        if (item.start_time != 0 && (prev_start_time.trim() != time_convert(item.start_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").attr('data-value', time_convert(item.start_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").val(time_convert(item.start_time));
                        }
                        if (item.end_time != 0 && (prev_end_time.trim() != time_convert(item.end_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").attr('data-value', time_convert(item.end_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").val(time_convert(item.end_time));
                        }
                        if (item.status == 'inactive') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'unchecked');
                        } else if (item.status == 'active') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'checked');
                        }
                        window.$("#" + item.day + "_breakfast_id").val(item.id);
                    } else if (item.meal == 'lunch') {
                        if (item.start_time != 0 && (prev_start_time.trim() != time_convert(item.start_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").attr('data-value', time_convert(item.start_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").val(time_convert(item.start_time));
                        }
                        if (item.end_time != 0 && (prev_end_time.trim() != time_convert(item.end_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").attr('data-value', time_convert(item.end_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").val(time_convert(item.end_time));
                        }
                        window.$("#" + item.day + "_lunch_id").val(item.id);
                        if (item.status == 'inactive') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'unchecked');
                        } else if (item.status == 'active') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'checked');
                        }
                    } else if (item.meal == 'dinner') {
                        if (item.start_time != 0 && (prev_start_time.trim() != time_convert(item.start_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").attr('data-value', time_convert(item.start_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_start_time]").val(time_convert(item.start_time));
                        }
                        if (item.end_time != 0 && (prev_end_time.trim() != time_convert(item.end_time))) {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").attr('data-value', time_convert(item.end_time));
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_end_time]").val(time_convert(item.end_time));
                        }
                        window.$("#" + item.day + "_dinner_id").val(item.id);
                        if (item.status == 'inactive') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'unchecked');
                        } else if (item.status == 'active') {
                            window.$("[uniq_id=" + item.day + "_" + item.meal + "_status]").attr('data-value', 'checked');
                        }
                    }
                });
            }
            window.toastr.success(response.data.message, response.statusText);
            $("#availabilityTableItem").find('.error').removeClass('error');
        }).catch(function (error) {
            if (typeof error.response !== 'undefined') {
                var responseVal = '';
                if (error.response.status == 400) {
                    var res_data = error.response.data;
                    if (res_data) {
                        for (const property in res_data) {
                            currentObj.closest("tr").find("input[name=" + property + "]").addClass('error');
                            responseVal = res_data[property];
                        }
                        window.toastr.error(responseVal, error.response.data.statusText);
                    }

                    return false;
                } else if (error.response.status == 409) {
                    var res_data = error.response.data;
                    if (res_data) {
                        currentObj.closest("tr").find("." + res_data['key']).addClass('error');
                        responseVal = res_data['message'];
                        window.toastr.error(responseVal, error.response.data.statusText);
                    }
                    return false;
                }
                if (error.response.data.message) {
                    window.toastr.error(error.response.data.message, error.response.data.statusText);
                }
            }
        });
    } else {
        window.toastr.error(window.$("#reservationTimeForm").attr('invalid-msg'));
    }
});

function time_convert(num) {
    if (num && num != 0 && num != '0') {
        var hours = Math.floor(num / 60);
        var minutes = num % 60;
        return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
    }

}
// Validation input have empty or not
function validationDisplayWithoutMessage(currentObject) {
    currentObject.removeClass('error');
    if (currentObject.val() == "" || !validateHhMm(currentObject.val())) {
        currentObject.addClass('error');
        return false;
    }
    return true;
}


// Validate hours and minute format
function validateHhMm(time) {
    return /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(time);
}

window.$("#datepicker2").datetimepicker({
    timepicker: false,
    format: DATE_FORMAT,
    dayOfWeekStart: 1,
    inline:true,
    /*yearStart: 1900,
    yearEnd: new Date().getFullYear(),
    monthStart: 0,
    monthEnd: new Date().getMonth(),
    maxDate: 0,*/
   
    onChangeYear: function (dateText, inst) {
        var year = moment(dateText).format('Y');
        var month = moment(dateText).format('M');
        var newDate = new Date();
        newDate.setMonth(month - 1);
        newDate.setYear(year);
        displayCalendar(newDate);
    },
    onChangeMonth: function (dateText, inst) {
        var year = moment(dateText).format('Y');
        var month = moment(dateText).format('M');
        var newDate = new Date();
        newDate.setMonth(month - 1);
        newDate.setYear(year);
        displayCalendar(newDate);
    },
    onSelectDate: function (dateText, inst) {
        var date = moment(dateText).format('Y-M-D');
        displayCalendar(date);
     }

}).focus(function () {
    window.$(".xdsoft_prev").hide();
    window.$(".xdsoft_next").hide();
});

/*datetimepicker({
    firstDay: 1,
    onSelect: function (selectDate, inst) {
        displayCalendar(selectDate);
    },
    onChangeMonthYear: function (year, month, datepicker) {
        var newDate = new Date();
        newDate.setMonth(month - 1);
        newDate.setYear(year);
        displayCalendar(newDate);
    }
});*/

// To display calender based on selected date year month
function displayCalendar(ct) {
    var mondayDate = getPreviousMonday(ct);
    var currentDate = new Date(ct);
    var dayIndex = currentDate.getDay();

    if (dayIndex !== 0) {
        var sundayDate = nextSunday(7, ct);
    } else if (dayIndex === 0) {
        var p_date = ("0" + (currentDate.getDate())).slice(-2);
        var p_month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
        var p_year = currentDate.getFullYear();
        var sundayDate = p_year + "-" + p_month + "-" + p_date;
    }
    $("#visible_start").val(mondayDate);
    $("#visible_end").val(sundayDate);
    renderCalendar($("#lastRenderURL").val());
}



// get previouse monday date
function getPreviousMonday(ct) {
    if (ct) {
        var currentDateObj = new Date(ct);
    } else {
        var currentDateObj = new Date();
    }
    currentDateObj.setDate(currentDateObj.getDate() - (currentDateObj.getDay() + 6) % 7);
    var p_date = ("0" + currentDateObj.getDate()).slice(-2);
    var p_month = ("0" + (currentDateObj.getMonth() + 1)).slice(-2);
    var p_year = currentDateObj.getFullYear();
    // return currentDateObj;
    return p_year + "-" + p_month + "-" + p_date;
}

//get next sunday date
function nextSunday(dayIndex, selectdate) {
    var givendate = new Date(selectdate || new Date());
    givendate.setDate(givendate.getDate() + (dayIndex - 1 - givendate.getDay() + 7) % 7 + 1);
    var p_date = ("0" + (givendate.getDate())).slice(-2);
    var p_month = ("0" + (givendate.getMonth() + 1)).slice(-2);
    var p_year = givendate.getFullYear();
    return p_year + "-" + p_month + "-" + p_date;
}

// data table for exception listing
var table = window.$('.exceptionSmallTable').DataTable({
    "ordering": false,
    "searching": false,
    "info": false,
    "bPaginate": false,
    "bLengthChange": false,
    "bFilter": true,
    "bInfo": false,
    "bAutoWidth": false,
    "oLanguage": {
        "sEmptyTable": "No future exception data"
    },
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".exceptionSmallTable").attr('link'),
        "type": "GET",
        "data": {
            "limit": 3,
        },
    },
    columns: [
        { data: 'dateRange', name: 'Date Range' },
        { data: 'channel', name: 'Mode' },
        { data: 'reason', name: 'Reason' },
        { data: 'action', name: 'Action', orderable: false, searchable: false }
    ]
});
// data table for exception listing
var table = window.$('.exceptionOpenSmallTable').DataTable({
    "ordering": false,
    "searching": false,
    "info": false,
    "bPaginate": false,
    "bLengthChange": false,
    "bFilter": true,
    "bInfo": false,
    "bAutoWidth": false,
    "oLanguage": {
        "sEmptyTable": "No future exception data"
    },
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".exceptionOpenSmallTable").attr('link'),
        "type": "GET",
        "data": {
            "limit": 3,
        },
    },
    columns: [
        { data: 'dateRange', name: 'Date Range' },
        { data: 'reason', name: 'Reason' },
        { data: 'action', name: 'Action', orderable: false, searchable: false }
    ]
});
/**
 * Delete Exception close time
 */
window.$(document).on('click', '.exceptionSmallTable .deleteException', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".exceptionSmallTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".exceptionSmallTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
                renderCalendar($("#lastRenderURL").val());
                setTimeout(function () {
                    if (!window.$(".exceptionSmallTable").DataTable().data().any()) {
                        window.$(".viewalllink > a").text('View all History')
                        //window.$(".viewalllink").hide();
                    } else {
                        window.$(".viewalllink > a").text('View all')
                        //window.$(".viewalllink").show();
                    }
                }, 500);


            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        return false;
    });
});
/**
 * Delete Exception close time
 */
window.$(document).on('click', '.exceptionOpenSmallTable .deleteException', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".exceptionOpenSmallTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".exceptionOpenSmallTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
                renderCalendar($("#lastRenderURL").val());
                setTimeout(function () {
                    if (!window.$(".exceptionOpenSmallTable").DataTable().data().any()) {
                        window.$(".viewalllink").hide();
                    } else {
                        window.$(".viewalllink").show();
                    }
                }, 500);


            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        return false;
    });
});
/**
 * Delete Exception close time
 */
 window.$(document).on('click', '.exceptionOpenSmallTable .deleteException', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".exceptionOpenSmallTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".exceptionOpenSmallTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
                renderCalendar($("#lastRenderURL").val());
                setTimeout(function(){
                    if(!window.$(".exceptionOpenSmallTable").DataTable().data().any()){
                        window.$(".viewalllink").hide();
                    }else{
                        window.$(".viewalllink").show();
                    }
                },500);
                

            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        return false;
    });
});
window.$("#reservation_time").on('click', function (e) {
    var appendParam = '';
    var exceptionParam = 'all';
    var openParam = 'yes';

    if ($(this).prop("checked") == true && $("#closing_time").is(':checked')) {
        appendParam = 'all'
    } else if ($(this).prop("checked") == true && $("#closing_time").is(':not(:checked)')) {
        appendParam = 'reservation';
    } else if ($(this).prop("checked") == false && $("#closing_time").is(':not(:checked)')) {
        appendParam = '';
    } else if ($(this).prop("checked") == false && $("#closing_time").is(':checked')) {
        appendParam = 'closing';
    }
    if ($("#online_time").is(':checked') && $("#offline_time").is(':not(:checked)')) {
        exceptionParam = 'online';
        if ($(this).prop("checked") == false && $("#closing_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':checked')) {
        exceptionParam = 'offline';
        if ($(this).prop("checked") == false && $("#closing_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':not(:checked)')) {
        exceptionParam = '';
        if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
            appendParam = '';
        } else {
            exceptionParam = '';
        }
    }
    if ($("#open_time").is(':not(:checked)')) {
        openParam = 'no'
    }
    renderCalendar(window.$("#availabilityCalendar").attr('link') + '?index=true&type=' + appendParam + '&exceptionType=' + exceptionParam + '&openExceptionType=' + openParam);
});
window.$("#closing_time").on('click', function (e) {
    var appendParam = 'all';
    var exceptionParam = 'all';
    var openParam = 'yes';

    if ($(this).prop("checked") == true && $("#reservation_time").is(':checked')) {
        appendParam = 'all'
    } else if ($(this).prop("checked") == true && $("#reservation_time").is(':not(:checked)')) {
        appendParam = 'closing';
    } else if ($(this).prop("checked") == false && $("#reservation_time").is(':not(:checked)')) {
        appendParam = '';
    } else if ($(this).prop("checked") == false && $("#reservation_time").is(':checked')) {
        appendParam = 'reservation';
    }
    if ($("#online_time").is(':checked') && $("#offline_time").is(':not(:checked)')) {
        exceptionParam = 'online';
        if ($(this).prop("checked") == false && $("#reservation_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':checked')) {
        exceptionParam = 'offline';
        if ($(this).prop("checked") == false && $("#closing_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':not(:checked)')) {
        exceptionParam = '';
        if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
            appendParam = '';
        } else {
            exceptionParam = '';
        }
    }
    if ($("#open_time").is(':not(:checked)')) {
        openParam = 'no'
    }
    renderCalendar(window.$("#availabilityCalendar").attr('link') + '?index=true&type=' + appendParam + '&exceptionType=' + exceptionParam + '&openExceptionType=' + openParam);
});

window.$("#online_time").on('click', function (e) {
    var appendParam = 'all';
    var reservationParam = 'all';
    var openParam = 'yes';

    if ($(this).prop("checked") == true && $("#offline_time").is(':checked')) {
        appendParam = 'all'
    } else if ($(this).prop("checked") == true && $("#offline_time").is(':not(:checked)')) {
        appendParam = 'online';
    } else if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
        appendParam = '';
    } else if ($(this).prop("checked") == false && $("#offline_time").is(':checked')) {
        appendParam = 'offline';
    }
    if ($("#reservation_time").is(':checked') && $("#closing_time").is(':not(:checked)')) {
        reservationParam = 'reservation';
        if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':checked')) {
        reservationParam = 'closing';
        if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':not(:checked)')) {
        reservationParam = '';
        if ($(this).prop("checked") == false && $("#offline_time").is(':not(:checked)')) {
            appendParam = '';
        } else {
            reservationParam = '';
        }
    }
    if ($("#open_time").is(':not(:checked)')) {
        openParam = 'no'
    }
    renderCalendar(window.$("#availabilityCalendar").attr('link') + '?index=true&type=' + reservationParam + '&exceptionType=' + appendParam + '&openExceptionType=' + openParam);
});

window.$("#offline_time").on('click', function (e) {
    var appendParam = 'all';
    var reservationParam = 'all';
    var openParam = 'yes';

    if ($(this).prop("checked") == true && $("#online_time").is(':checked')) {
        appendParam = 'all'
    } else if ($(this).prop("checked") == true && $("#online_time").is(':not(:checked)')) {
        appendParam = 'offline';
    } else if ($(this).prop("checked") == false && $("#online_time").is(':not(:checked)')) {
        appendParam = '';
    } else if ($(this).prop("checked") == false && $("#online_time").is(':checked')) {
        appendParam = 'online';
    }

    if ($("#reservation_time").is(':checked') && $("#closing_time").is(':not(:checked)')) {
        if ($(this).prop("checked") == false && $("#online_time").is(':not(:checked)')) {
            appendParam = '';
        }
        reservationParam = 'reservation';
    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':checked')) {
        reservationParam = 'closing';
        if ($(this).prop("checked") == false && $("#online_time").is(':not(:checked)')) {
            appendParam = '';
        }
    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':not(:checked)')) {
        reservationParam = '';
        if ($(this).prop("checked") == false && $("#online_time").is(':not(:checked)')) {
            appendParam = '';
        } else {
            reservationParam = '';
        }
    }
    if ($("#open_time").is(':not(:checked)')) {
        openParam = 'no'
    }
    renderCalendar(window.$("#availabilityCalendar").attr('link') + '?index=true&type=' + reservationParam + '&exceptionType=' + appendParam + '&openExceptionType=' + openParam);
});


window.$("#open_time").on('click', function (e) {
    var appendParam = 'all';
    var reservationParam = 'all';
    var openParam = 'yes';
    var exceptionParam = '';

    if ($("#online_time").is(':checked') && $("#offline_time").is(':not(:checked)')) {
        appendParam = 'online';

    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':checked')) {
        appendParam = 'offline';

    } else if ($("#online_time").is(':not(:checked)') && $("#offline_time").is(':not(:checked)')) {
        appendParam = '';

    }

    if ($("#reservation_time").is(':checked') && $("#closing_time").is(':not(:checked)')) {
        reservationParam = 'reservation';
    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':checked')) {
        reservationParam = 'closing';

    } else if ($("#reservation_time").is(':not(:checked)') && $("#closing_time").is(':not(:checked)')) {
        reservationParam = '';

    }
    if ($("#open_time").is(':not(:checked)')) {
        openParam = 'no'
    }
    renderCalendar(window.$("#availabilityCalendar").attr('link') + '?index=true&type=' + reservationParam + '&exceptionType=' + appendParam + '&openExceptionType=' + openParam);
});

var data = [];
var calendar = '';

window.addEventListener('DOMContentLoaded', function () {
    var checkPrevTime = function () {
        var currenVal = this.value;
        var attrVal = this.getAttribute("data-value");
        var thisName = $(this).prop('name').split('_');
        var ischecked = '';
        if (attrVal.trim() != currenVal) {
            console.log("insid");
            $(this).closest('tr').find('td:last a').removeClass('disabled');
        } else {
            if (thisName[1] == 'end') {
                var prevVal = $(this).closest('td').prev('td').find('div:first').find('input').val();
                var prevValAttr = $(this).closest('td').prev('td').find('div:first').find('input').attr('data-value');
                let currentStatus = $(this).closest('td').next('td').find('label').find('input');
                let currentStatusAttr = $(this).closest('td').next('td').find('label').find('input').attr('data-value');
                if (currentStatus.is(":checked")) {
                    ischecked = 'checked';
                }
                else if (currentStatus.is(":not(:checked)")) {
                    ischecked = 'unchecked';
                }
                if (prevValAttr.trim() != prevVal || ischecked != currentStatusAttr) {
                    $(this).closest('tr').find('td:last a').removeClass('disabled');
                } else {
                    $(this).closest('tr').find('td:last a').addClass('disabled');
                    $(".textfield").removeClass('error');
                }
            } else if (thisName[1] == 'start') {
                var prevVal = $(this).closest('td').next('td').find('div:first').find('input').val();
                var prevValAttr = $(this).closest('td').next('td').find('div:first').find('input').attr('data-value');
                let currentStatus = $(this).closest('td').next('td').next('td').find('label').find('input');
                let currentStatusAttr = $(this).closest('td').next('td').next('td').find('label').find('input').attr('data-value');
                if (currentStatus.is(":checked")) {
                    ischecked = 'checked';
                }
                else if (currentStatus.is(":not(:checked)")) {
                    ischecked = 'unchecked';
                }
                if (prevValAttr.trim() != prevVal || ischecked != currentStatusAttr) {
                    $(this).closest('tr').find('td:last a').removeClass('disabled');
                } else {
                    $(this).closest('tr').find('td:last a').addClass('disabled');
                    $(".textfield").removeClass('error');
                }
            } else {
                $(this).closest('tr').find('td:last a').addClass('disabled');
                $(".textfield").removeClass('error');
            }
        }
    };
    var textfield = document.getElementsByClassName("textfield");
    ['change'].forEach(event => {
        Array.from(textfield).forEach(function (element) {
            element.addEventListener(event, checkPrevTime, false);
        });
    });
    window.$(".textfield").on('change', function (event) {
        var currenVal = this.value;
        var attrVal = this.getAttribute("data-value");
        var thisName = $(this).prop('name').split('_');
        var ischecked = '';
        // console.log(currenVal);
        // console.log(attrVal);
        if (attrVal && attrVal.trim() != currenVal) {
            console.log("insid");
            $(this).closest('tr').find('td:last a').removeClass('disabled');
        } else {
            if (thisName[1] == 'end') {
                var prevVal = $(this).closest('td').prev('td').find('div:first').find('input').val();
                var prevValAttr = $(this).closest('td').prev('td').find('div:first').find('input').attr('data-value');
                let currentStatus = $(this).closest('td').next('td').find('label').find('input');
                let currentStatusAttr = $(this).closest('td').next('td').find('label').find('input').attr('data-value');
                if (currentStatus.is(":checked")) {
                    ischecked = 'checked';
                }
                else if (currentStatus.is(":not(:checked)")) {
                    ischecked = 'unchecked';
                }
                if (prevValAttr && prevValAttr.trim() != prevVal || ischecked != currentStatusAttr) {
                    $(this).closest('tr').find('td:last a').removeClass('disabled');
                } else {
                    $(this).closest('tr').find('td:last a').addClass('disabled');
                    $(".textfield").removeClass('error');
                }
            } else if (thisName[1] == 'start') {
                var prevVal = $(this).closest('td').next('td').find('div:first').find('input').val();
                var prevValAttr = $(this).closest('td').next('td').find('div:first').find('input').attr('data-value');
                let currentStatus = $(this).closest('td').next('td').next('td').find('label').find('input');
                let currentStatusAttr = $(this).closest('td').next('td').next('td').find('label').find('input').attr('data-value');
                if (currentStatus.is(":checked")) {
                    ischecked = 'checked';
                }
                else if (currentStatus.is(":not(:checked)")) {
                    ischecked = 'unchecked';
                }
                if (prevValAttr && prevValAttr.trim() != prevVal || ischecked != currentStatusAttr) {
                    $(this).closest('tr').find('td:last a').removeClass('disabled');
                } else {
                    $(this).closest('tr').find('td:last a').addClass('disabled');
                    $(".textfield").removeClass('error');
                }
            } else {
                $(this).closest('tr').find('td:last a').addClass('disabled');
                $(".textfield").removeClass('error');
            }
        }
    });
});


if (window.$(".container-fluid").hasClass('availabilityHome')) {
    document.addEventListener('DOMContentLoaded', function () {
        var start_date = ($("#visible_start").val()) ? $("#visible_start").val() : getPreviousMonday();
        var end_date = ($("#visible_end").val()) ? $("#visible_end").val() : nextSunday(7);
        var eventURL = window.$("#availabilityCalendar").attr('link') + '?index=true&type=all&exceptionType=all&openExceptionType=yes&start_date=' + start_date + '&end_date=' + end_date;
        renderCalendar(eventURL);
    });
}

function renderCalendar(eventURL) {
    var calendarEl = document.getElementById('availabilityCalendar');
    $("#lastRenderURL").val(replaceUrlParam(eventURL, 'start_date', ($("#visible_start").val()) ? $("#visible_start").val() : getPreviousMonday()));
    $("#lastRenderURL").val(replaceUrlParam($("#lastRenderURL").val(), 'end_date', ($("#visible_end").val()) ? $("#visible_end").val() : nextSunday(7)));
    eventURL = $("#lastRenderURL").val();
    calendar = new Calendar(calendarEl, {
        headerToolbar: {
            left: '',
            center: '',
            right: 'prev today next'
        },
        dayHeaderContent: (args) => {
            return moment(args.date, "YYYY-MM-DD HH:mm:ss").format('DD.MM');
        },
        contentHeight: "auto",
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        events: eventURL,
        initialView: 'timeGrid',
        locale: 'en-GB',
        eventTimeFormat: {
            hour: '2-digit', //2-digit, numeric
            minute: '2-digit', //2-digit, numeric
            meridiem: false, //lowercase, short, narrow, false (display of AM/PM)
            hour12: false //true, false
        },
        slotLabelFormat: {
            hour: 'numeric',
            minute: '2-digit',
            omitZeroMinute: false,
            hour12: false, //true, false
        },
        visibleRange: {
            start: new Date(($("#visible_start").val()) ? $("#visible_start").val() : getPreviousMonday()),
            end: new Date(($("#visible_end").val()) ? $("#visible_end").val() : nextSunday(7))
        },
        eventClick: function (info) {

        },
        dateClick: function (info) {

        },
        select: function (info) {
        },
        dayMaxEvents: false, // allow "more" link when too many events
    });

    calendar.render();
}
$('body').on('click', '#availabilityCalendar button.fc-prev-button', function () {
    var start = $("#visible_start").val();
    var end = $("#visible_end").val();
    //get previous monday
    var mondayDate = getPreviousMonday();
    var mondayDate = new Date(mondayDate);
    if (start !== "") {
        var mondayDate = new Date(start);
    }

    mondayDate.setDate(mondayDate.getDate() - 7);
    var p_date = ("0" + (mondayDate.getDate())).slice(-2);
    var p_month = ("0" + (mondayDate.getMonth() + 1)).slice(-2);
    var p_year = mondayDate.getFullYear();
    var mondayDate = p_year + "-" + p_month + "-" + p_date;
    var setMonday = p_month + "/" + p_date + "-" + p_year;
    $("#datepicker2").datetimepicker({defaultDate: new Date(setMonday)}) .datetimepicker('reset');
    $("#visible_start").val(mondayDate);

    //get previous sunday
    var sundayDate = nextSunday(7, mondayDate);

    var sundayDate = new Date(sundayDate);
    sundayDate.setDate(sundayDate.getDate() - 1);
    if (end !== "") {
        var sundayDate = new Date(mondayDate);
        sundayDate.setDate(sundayDate.getDate() + 6);
    }
    var p_date = ("0" + (sundayDate.getDate())).slice(-2);
    var p_month = ("0" + (sundayDate.getMonth() + 1)).slice(-2);
    var p_year = sundayDate.getFullYear();
    var sundayDate = p_year + "-" + p_month + "-" + p_date;
    $("#visible_end").val(sundayDate);
    renderCalendar($("#lastRenderURL").val());

});

function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
        return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}
//Next week function
$('body').on('click', '#availabilityCalendar button.fc-next-button', function () {
    var start = $("#visible_start").val();
    var end = $("#visible_end").val();

    //get previous monday
    var mondayDate = getPreviousMonday();
    var mondayDate = new Date(mondayDate);
    if (start !== "") {
        var mondayDate = new Date(start);
    }
    mondayDate.setDate(mondayDate.getDate() + 7);
    var p_date = ("0" + (mondayDate.getDate())).slice(-2);
    var p_month = ("0" + (mondayDate.getMonth() + 1)).slice(-2);
    var p_year = mondayDate.getFullYear();
    var mondayDate = p_year + "-" + p_month + "-" + p_date;
    var setMonday = p_month + "/" + p_date + "-" + p_year;
    $("#datepicker2").datetimepicker({defaultDate: new Date(setMonday)}) .datetimepicker('reset');
    $("#visible_start").val(mondayDate);

    //get previous sunday
    var sundayDate = nextSunday(7, mondayDate);
    var sundayDate = new Date(sundayDate);
    sundayDate.setDate(sundayDate.getDate());
    if (end !== "") {
        var sundayDate = new Date(mondayDate);
        sundayDate.setDate(sundayDate.getDate() + 6);
    }
    var p_date = ("0" + (sundayDate.getDate())).slice(-2);
    var p_month = ("0" + (sundayDate.getMonth() + 1)).slice(-2);
    var p_year = sundayDate.getFullYear();
    var sundayDate = p_year + "-" + p_month + "-" + p_date;
    $("#visible_end").val(sundayDate);

    renderCalendar($("#lastRenderURL").val());
});

//Next week function
$('body').on('click', '#availabilityCalendar button.fc-today-button', function () {
    var todayDate = new Date();
    $("#datepicker2").datetimepicker({defaultDate: todayDate}).datetimepicker('reset');
    var mondayDate = getPreviousMonday(todayDate);
    var mondayDate = new Date(mondayDate);
    var p_date = ("0" + (mondayDate.getDate())).slice(-2);
    var p_month = ("0" + (mondayDate.getMonth() + 1)).slice(-2);
    var p_year = mondayDate.getFullYear();
    var mondayDate = p_year + "-" + p_month + "-" + p_date;
    $("#visible_start").val(mondayDate);
    var sundayDate = nextSunday(7, mondayDate);
    var sundayDate = new Date(sundayDate);
    sundayDate.setDate(sundayDate.getDate() - 1);
    var p_date = ("0" + (sundayDate.getDate() + 1)).slice(-2);
    var p_month = ("0" + (sundayDate.getMonth() + 1)).slice(-2);
    var p_year = sundayDate.getFullYear();
    var sundayDate = p_year + "-" + p_month + "-" + p_date;
    $("#visible_end").val(sundayDate);
    renderCalendar($("#lastRenderURL").val());

});
if (window.location.pathname == '/core/reservationTime') {
    window.onbeforeunload = function (e) {
        if ($(".disabled").length != 7) {
            e = e || window.event;
            // For IE and Firefox
            if (e) {
                e.returnValue = null;
            }
            // For Safari
            return null;
        } else {

        }
    }
} else {
    window.onbeforeunload = null;
}
